import { OfferAcceptanceStatus, OfferAcceptanceType, } from '@/api/v2/requests/offers';
export const useAcceptanceColumns = (ctx, { offer, decisionSelectId, isReadOnlyAcceptance }) => {
    const acceptanceColumns = [
        {
            field: 'statuses',
            colId: decisionSelectId,
            headerName: ctx.root.$t('offer-costs.decisionLabel').toString(),
            width: 200,
            cellRenderer: 'ObjectDecisionCell',
            cellRendererParams: (params) => {
                return {
                    centralStatus: params?.value,
                };
            },
            pinned: 'right',
            suppressMovable: true,
            valueGetter: (params) => {
                const centralStatus = (params?.data?.statuses ?? []).find((status) => status.type === OfferAcceptanceType.CENTRAL);
                return centralStatus?.status;
            },
            ...(isReadOnlyAcceptance
                ? {}
                : {
                    filter: true,
                    floatingFilter: true,
                    suppressHeaderMenuButton: true,
                    floatingFilterComponent: 'FloatingSelectFilter',
                    floatingFilterComponentParams: () => {
                        return {
                            id: decisionSelectId,
                            options: [
                                OfferAcceptanceStatus.ACCEPTED,
                                OfferAcceptanceStatus.REJECTED,
                                OfferAcceptanceStatus.REVERTED,
                            ].map((value) => ({ value, label: value })),
                            getLabel: (value) => {
                                return ctx.root.$t(`offer-costs.decision.${value}`);
                            },
                        };
                    },
                    suppressFloatingFilterButton: true,
                }),
        },
        {
            field: 'statuses',
            colId: 'centralStatus',
            sortable: false,
            headerName: ctx.root.$t('offer-costs.central').toString(),
            width: 70,
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.CENTRAL,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
        {
            field: 'statuses',
            colId: 'structureStatus',
            sortable: false,
            width: 70,
            headerName: ctx.root.$t('offer-costs.structure').toString(),
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.STRUCTURE,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
        {
            field: 'statuses',
            colId: 'placeStatus',
            sortable: false,
            width: 70,
            headerName: ctx.root.$t('offer-costs.place').toString(),
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.PLACE,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
    ];
    return { acceptanceColumns };
};
